import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { gallery as defaultGallery } from '../mock';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const GALLERY_MAX = 4;

const Gallery = () => {
  const [selected, setSelected] = useState(null);
  const [images, setImages] = useState(defaultGallery.slice(0, GALLERY_MAX));

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`).then((r) => {
      const arr = r.data?.gallery_images;
      if (Array.isArray(arr) && arr.length) setImages(arr.slice(0, GALLERY_MAX));
    }).catch(() => {});
  }, []);

  return (
    <section id="galerie" className="bg-[#FAF7F2] py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-[#F4A340]/10 text-[#E89534] text-xs font-semibold tracking-widest uppercase mb-4">
            Galerie
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 leading-tight">
            Moments capturés sur <span className="text-[#E89534]">l'eau</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 md:grid-rows-2 gap-4 md:h-[560px]" data-testid="gallery-grid">
          {images.map((img, i) => {
            // Layout mosaïque : [0] grande à gauche (2×2), [1] rectangle en haut à droite (2×1),
            // [2] carrée bas-milieu, [3] carrée bas-droite.
            let cls = 'aspect-square';
            if (i === 0) cls = 'md:col-span-2 md:row-span-2 aspect-square md:aspect-auto';
            else if (i === 1) cls = 'md:col-span-2 aspect-square md:aspect-auto';
            else cls = 'aspect-square md:aspect-auto';
            return (
              <button
                key={`${i}-${img}`}
                onClick={() => setSelected(img)}
                className={`relative overflow-hidden rounded-2xl group shadow-md hover:shadow-xl transition-shadow ${cls}`}
                data-testid={`gallery-item-${i}`}
              >
                <img
                  src={img}
                  alt={`Galerie ${i + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-4 left-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-10 h-10 rotate-45 border-2 border-white flex items-center justify-center">
                    <span className="-rotate-45 text-sm font-bold">+</span>
                  </div>
                </div>
              </button>
            );
          })}
        </div>
      </div>

      {selected && (
        <div
          className="fixed inset-0 z-[70] bg-slate-900/90 backdrop-blur-md flex items-center justify-center p-6 animate-in fade-in duration-300"
          onClick={() => setSelected(null)}
        >
          <button
            className="absolute top-6 right-6 w-12 h-12 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center text-white transition-colors"
            onClick={() => setSelected(null)}
          >
            <X className="w-6 h-6" />
          </button>
          <img src={selected} alt="Grand format" className="max-w-full max-h-full rounded-2xl shadow-2xl" />
        </div>
      )}
    </section>
  );
};

export default Gallery;
